import ProjectScopeDocEditFormModule from './scope-doc-edit-form.module'

export default ProjectScopeDocEditFormModule
